import React, { useEffect, useState } from "react";
import StepperKyc from "../../../components/StepperKyc";
import { formatString } from "../../../utils/handlers";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";
import NoDataFound from "../../../components/NoDataFound";
import ReinitiateLoanModal from "./ReinitiateLoanModal";
import VanishComponent from "../../../components/VanishComponent";
import DownloadLoadingModal from "../../../components/DownloadLoadingModal";
import CloseLoanModal from "./CloseLoanModal";

function OrderTimeline({ orderId }) {
  const token = localStorage.getItem("token");

  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noDataFound, setNoDataFound] = useState(false);
  const [reinitiateLoan, setReinitiateLoan] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [reinitiateOpen, setReinitiateOpen] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [initiateLoading, setInitiateLoading] = useState(false);
  const [closeLoan, setCloseLoan] = useState(false);
  const [closeLoanModal, setCloseLoanModal] = useState(false);

  const getUserDetails = async () => {
    setNoDataFound(false);
    setLoading(true);
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/orders/${orderId}/order_timeline`,
        options
      );
      if (res.data.status === true) {
        setReinitiateLoan(res?.data?.data?.loan_timeline?.reinitiate_loan);
        setCloseLoan(res?.data?.data?.loan_timeline?.close_loan);
        setTimelineData(
          handlePosition(res?.data?.data?.loan_timeline?.order_timeline)
        );
      } else {
        setTimelineData([]);
        setNoDataFound(true);
      }
    } catch (error) {
      setTimelineData([]);
      setNoDataFound(true);
    } finally {
      setLoading(false);
    }
  };
  const reinitiateHandler = async (initiateMethod) => {
    setInitiateLoading(true);
    const options = {
      method: "POST",
      headers: { Authorization: token },
      data: {
        [initiateMethod]: {
          order_uuid: orderId,
        },
      },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/bajaj_finserv/service/${initiateMethod}`,
        options
      );
      const message = res?.data?.data?.message;
      if (res?.data?.status === true) {
        setTimeout(() => {
          setSuccess(message || "Reinitiation successful");
          setInitiateLoading(false);
          setRerender((prev) => !prev);
        }, 5000);
      } else {
        const errorMessage = res?.data?.error;
        setError(message || errorMessage || "Failed to Reinitiate");
        setInitiateLoading(false);
      }
    } catch (error) {
      setError("Failed to Reinitiate");
      setInitiateLoading(false);
    } finally {
    }
  };

  const initiateMethodMap = {
    e_signature: "kfs_eagreement",
    e_mandate: "emandate_reinitiate",
  };
  const handlePosition = (data, index) => {
    if (!data) return [];
    return data.map(({ name, status, url, reinitiate }) => ({
      name: formatString(name),
      description: "",
      href: "",
      status: status ? "current" : "",
      download: index,
      last: false,
      ...(url && { url }),
      ...(reinitiate && { reinitiateStatus: reinitiate }),
      ...(initiateMethodMap[name] && {
        initiateMethod: initiateMethodMap[name],
      }),
    }));
  };

  useEffect(() => {
    getUserDetails();
  }, [rerender]);
  return (
    <>
      {loading && !noDataFound && (
        <div className="w-full h-[calc(100vh-280px)] flex justify-center items-center bg-white">
          <ImageLoading />
        </div>
      )}
      {!loading && noDataFound && (
        <div className="w-full h-[calc(100vh-280px)] flex justify-center items-center bg-white">
          <NoDataFound />
        </div>
      )}
      {!loading && !noDataFound && (
        <div className="border min-w-[350px] border-solid border-[#E6EBED] px-4 pt-1 py-4 rounded-lg w-fit h-full mt-4">
          <div className="mt-3 flex justify-between items-center">
            <p className=" text-base font-bold">Order Timeline</p>
            <div className=" flex items-center gap-2">
              {reinitiateLoan && (
                <button
                  onClick={() => {
                    setReinitiateOpen(true);
                  }}
                  className="  border border-[#00394d] text-[#00394d] rounded  py-[2px] px-2 text-[13px] font-medium"
                >
                  Reinitiate Loan
                </button>
              )}
              {closeLoan && (
                <button
                  onClick={() => {
                    setCloseLoanModal(true);
                  }}
                  className="  border bg-[#00394d] border-[#00394d] text-white rounded  py-[2px] px-2 text-[13px] font-medium"
                >
                  Close Loan
                </button>
              )}
            </div>
          </div>
          <div className="mt-3 h-[1px] w-full border border-solid border-[#F4F4F4]"></div>

          <div className="h-full mt-[2px]">
            <StepperKyc
              timeline={timelineData}
              orderId={orderId}
              reinitiateHandler={reinitiateHandler}
            />
          </div>
        </div>
      )}
      {reinitiateOpen && (
        <ReinitiateLoanModal
          orderId={orderId}
          setModal={setReinitiateOpen}
          setSuccessAPI={setSuccess}
          setErrorAPI={setError}
          setRerender={setRerender}
        />
      )}
      {closeLoanModal && (
        <CloseLoanModal
          closeModal={setCloseLoanModal}
          orderUuid={orderId}
          setSuccessAPI={setSuccess}
          setErrorAPI={setError}
          setRerender={setRerender}
        />
      )}
      <VanishComponent
        error={error}
        success={success}
        errorMessage={error}
        successMessage={success}
        errorFunction={() => {
          setError(false);
        }}
        successFunction={() => {
          setSuccess(false);
        }}
        timeOut={6000}
      />
      {initiateLoading && <DownloadLoadingModal />}
    </>
  );
}

export default OrderTimeline;
